import React, { useState, ChangeEvent, Dispatch, useEffect, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Field, reduxForm, InjectedFormProps } from "redux-form";
import { get, isEmpty, uniqBy } from "lodash";
import { scrollToErrorOnFormHandler,cacheManager} from "../../../helpers/util-common";
import RenderTypeahead from "../../../shared-components/Typeahead";
import { getActiveCommitteesFromIAAction } from "../../../redux/action/ballots";
import { AddAdminWorkitemModalProps, AdminWorkitemProps } from "../../WorkItems/interface";
import { Typeahead } from "react-bootstrap-typeahead";
import { getMemberListAction, addAdminWorkitemction, getWorkItemListAction, getCommitteeOfficerTitleAction } from "../../../redux/action/workItem";
import ReduxRadio from "../../../shared-components/Radio";
import AppealOnCOSForm from "./AppealOnCOSForm";
import { WI_TYPE } from "../../../../common.enum";
import commonActions from "../../../common.actions";
import { ADMIN_WORK_ITEM_TYPES } from "../../../models/common.models";

type Props = AddAdminWorkitemModalProps & InjectedFormProps<any, AddAdminWorkitemModalProps>;

 
const AddAdminWorkitemModal: React.FC<Props> = ({ showAddAdminWorkitemModal, closeAddAdminWorkitemModal, userEmail }: Props) => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [adminWorkitem, setAdminWorkitem] = useState<AdminWorkitemProps>();
  const [selectedCommitteeDesignation, setselectedCommitteeDesignation] = useState<any[]>([]);
  const [technicalContact, setTechnicalContact] = useState<any>([]);
  const [selectedTitle, setselectedTitle] = useState<string>();
  const [memberList, setMemberList] = useState<any>([]);
  const [invalidCommittee, setinvalidCommittee] = useState<boolean>(false);
  const [invalidTitle, setinvalidTitle] = useState<boolean>(false);
  const [committeeDesignationData, setcommitteeDesignationData] = useState<Array<any>>([]);
  const [clearAllTypeaheds, setClearAllTypeaheds] = useState<boolean>(false);
  const [customClass, setCustomClass] = useState("add-ballot-header-committee");
  const technicalContactRef = useRef(null);
  const [isLoadingMembers, setIsLoadingMembers] = useState(false);
  const dispatch = useDispatch();
  const workLitemResponse = useSelector((state: any) => state.commonReducer.workItemList);
  const globalSearchText = useSelector((state: any) => state.commonReducer.globalSearchText);
  const userDetail = cacheManager.getItem("userDetail") && JSON.parse(cacheManager.getItem("userDetail"));
  const [selectedAdminType, setSelectedAdminType] = useState<any>(null);
  const [activeTab, setActiveTab] = useState<WI_TYPE>(WI_TYPE.ADMIN);
  const [invalidAdminType, setInvalidAdminType] = useState<boolean>(false);
  const [showAppealModal, setShowAppealModal] = useState(false);
  const [committeeOfficerTitles, setCommitteeOfficerTitles] = useState<any>([]);
  const allCommittees = useSelector((state: any) => state.commonReducer.allCommittees);

  const { selectedQuickSearchWorkItemStatus, quickSearchSelectedUser, selectedQuickSearchWorkItemType, checkWorkItemSuppress, isUserOfficer, wiExtraField } = useSelector((state: any) => {
    return {
      selectedQuickSearchWorkItemStatus: state.commonReducer.selectedQuickSearchWorkItemStatus,
      quickSearchSelectedUser: state.commonReducer.quickSearchSelectedUser,
      selectedQuickSearchWorkItemType: state.commonReducer.selectedQuickSearchWorkItemType,
      checkWorkItemSuppress: state.commonReducer.checkWorkItemSuppress,
      isUserOfficer: state.commonReducer.isUserOfficer,
      wiExtraField: state.commonReducer.WorkItemExtraFields.filter(Boolean),
    };
  });

  useEffect(() => {
    if (selectedAdminType === WI_TYPE.APPEAL_ON_COS && committeeOfficerTitles?.length > 0) 
    {
        const defaultOfficer = committeeOfficerTitles.find(
          (item: any) => item.OfficerTitleId === 7
        );

        if (defaultOfficer) {
          const formatted = {
            label: `${defaultOfficer.LastName}, ${defaultOfficer.FirstName} (${defaultOfficer.MemberAccountNumber})`,
            value: defaultOfficer.MemberId,
          };

        setTechnicalContact([formatted]);

        setAdminWorkitem((prevState) => ({
          ...prevState,
          TechnicalContactId: defaultOfficer.MemberId,
        }));
      }
    }

    if (selectedAdminType === WI_TYPE.ADMIN) {
      setTechnicalContact([]);
    }
  }, [selectedAdminType, committeeOfficerTitles]);
 
  useEffect(() => {
    if(allCommittees?.length > 0){
    const CosCommittteeId = allCommittees?.find((item)=>item?.Code == "COS");
    const payload = [CosCommittteeId?.CommitteeId];

    getCommitteeOfficerTitleAction(payload, dispatch, (res) => {
      if (res ) {
        var data = committeeOfficerTitles;
        setCommitteeOfficerTitles(res);

        const defaultOfficer = res.find(
          (item: any) => item.OfficerTitleId === 7
        );

        if (defaultOfficer && selectedAdminType === WI_TYPE.APPEAL_ON_COS) {
          const formatted = {
            label: `${defaultOfficer.LastName}, ${defaultOfficer.FirstName} (${defaultOfficer.MemberAccountNumber})`,
            value: defaultOfficer.MemberId,
          };
           setMemberList([formatted]);
          setTechnicalContact([formatted]);

          setAdminWorkitem((prevState) => ({
            ...prevState,
            TechnicalContactId: defaultOfficer.MemberId,
          }));
        }
      } else {
        setCommitteeOfficerTitles([]);
      }
  });
  }
  }, [allCommittees]);

  useEffect(() => {
    setAdminWorkitem((prevState) => {
      return { ...prevState, UserId: userDetail.userId, UserName: `${userDetail.lastName}, ${userDetail.firstName}` };
    });
    getCommitteeList();
  }, []);

  const getCommitteeList = () => {
    getActiveCommitteesFromIAAction(dispatch, (response: any) => {
      if (response && response.length > 0) {
        const CommitteeList = uniqBy(
          response.map((x) => ({
            CommitteeId: `${x.CommitteeId}`,
            MainCommitteeId: x.ParentCommitteeId && x.ParentCommitteeId !== 0 ? `${x.ParentCommitteeId}` : `${x.CommitteeId}`,
            SubCommitteeId: x.ParentCommitteeId && x.ParentCommitteeId !== 0 ? `${x.CommitteeId}` : null,
            CommitteeDesignation: `${x.CommitteeDesignation || ""}`,
          })),
          "CommitteeDesignation"
        );
        setcommitteeDesignationData(CommitteeList);
      }
    });
  };

  const validateFormData = (data: AdminWorkitemProps): boolean => {
    let isValid = true;
    if (selectedCommitteeDesignation == undefined || selectedCommitteeDesignation?.length === 0 || selectedCommitteeDesignation[0] == undefined) {
      setinvalidCommittee(true);
      isValid = false;
    }
    if (!data.hasOwnProperty("Title") || !data.Title || data.Title.trim() === "") {
      setinvalidTitle(true);
      isValid = false;
    } else {
      setinvalidTitle(false);
    }
     if (!selectedAdminType) {
      setInvalidAdminType(true);
      isValid = false;
    } else {
      setInvalidAdminType(false);
    }
    return isValid;
  };

  const handleSubmit = () => {

    const updatedWorkitem = {
    ...adminWorkitem,
    IsAdmin: selectedAdminType === WI_TYPE.ADMIN ? 1 : 0,
    };
    if (validateFormData(updatedWorkitem)) {
      setIsSubmitting(true);
      dispatch(commonActions.setOverlayLoader(true));
      closeAddAdminWorkitemModal();
      addAdminWorkitemction(adminWorkitem,"post", dispatch, (response: any) => {
        if (response) {
          reloadWorkitemlist();
        } else{
            setIsSubmitting(false);
            dispatch(commonActions.setOverlayLoader(false));
        }
      });
    }
  };

  const reloadWorkitemlist = () => {
    const data = {
      pageNumber: workLitemResponse.paginationModel.PageNumber || 1,
      pageSize: workLitemResponse.paginationModel?.PageSize || 10,
      sortColumnWithOrder: {
        ModifiedDate: 2,
      },
      UserEmail: quickSearchSelectedUser ? quickSearchSelectedUser : "",
      WorkItemGlobalSearch: globalSearchText ? globalSearchText : "",
      ExtraFields: wiExtraField,
    };
    getWorkItemListAction(dispatch, data, (Result: any) => {
      dispatch(commonActions.setOverlayLoader(false));
    });
  };

  const onClose = () => {
    setIsSubmitting(false);
    closeAddAdminWorkitemModal();
    onReset();
  };

  const onReset = () => {
    setselectedTitle("");
    setselectedCommitteeDesignation([]);
    setTechnicalContact([]);
     setSelectedAdminType(null);
    setinvalidCommittee(false);  
    setinvalidTitle(false);
  };

  const addRemoveTypeaheadClass = (event: any) => {
    const keysToAddClassOn = ["Enter", "Backspace"];
    if (event.key === "ArrowDown") {
      event.target.value && setCustomClass("");
    } else if (keysToAddClassOn.indexOf(event.key) > -1) {
      setCustomClass("add-ballot-header-committee");
    }
  };

  const handleCommitteeSelectionInputKeyPress = (ev: { target: any; key: string }, textValue: string) => {
    if (clearAllTypeaheds) {
      setClearAllTypeaheds(false);
    }
    addRemoveTypeaheadClass(ev);
    if (ev.key === "Enter") {
      setCustomClass("add-ballot-header-committee");
      technicalContactRef.current.clear();
      if (!isEmpty(ev.target.value)) {
        const filteredData = committeeDesignationData.filter((item: any) => item.CommitteeDesignation && typeof item.CommitteeDesignation === "string" && item.CommitteeDesignation.toLowerCase().includes(ev.target.value.toLowerCase()));

        for (let i = 0; i < filteredData.length; i++) {
          validateOnChange([filteredData[i]]);
          setselectedCommitteeDesignation([filteredData[i]]);
          setAdminWorkitem((prevState) => {
            return { ...prevState, CommitteeDesignation: filteredData[i]?.CommitteeDesignation };
          });
          return;
        }
      }
    }
  };

  const onTitleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setselectedTitle(event.target.value);
    if (event.target.value.trim() != "") {
      setinvalidTitle(false);
    } else {
      setinvalidTitle(true);
    }
    setAdminWorkitem((prevState) => {
      return { ...prevState, Title: event.target.value };
    });
  };

  const validateOnChange = (value: any[]) => {
    setCustomClass("add-ballot-header-committee");
    if (clearAllTypeaheds) {
      setClearAllTypeaheds(false);
    }
    setselectedCommitteeDesignation(value);
    if (value[0] != "" && value[0] != null) {
      setinvalidCommittee(false);
    }
    if (value?.length && value[0] != null && value[0].CommitteeDesignation) {
      setAdminWorkitem((prevState) => {
        return { ...prevState, CommitteeDesignation: value[0].CommitteeDesignation, MainCommitteeId: value[0].MainCommitteeId, SubCommitteeId: value[0].SubCommitteeId };
      });
    }
    if (value[0] != "" && value[0] != null) {
    if(selectedAdminType === WI_TYPE.ADMIN )
      {
        setTechnicalContact([]);
         technicalContactRef.current.clear();
      }
      setMemberList([]);
      setIsLoadingMembers(true);
      getMemberListAction(value[0].CommitteeId, dispatch, (data) => {
        setMemberList(data?.content?.map((item: any) => ({ label: `${item.LastName}, ${item.FirstName} (${item.AccountNumber})`, value: item.MemberId })));
        setIsLoadingMembers(false);
      });
    }
  };

  const isDisabled = !selectedAdminType;

  return (
    <div className={`modal fade ${showAddAdminWorkitemModal ? "show" : ""} `} id="addBallotModal" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered add-ballot-popup modal-lg" role="document">
        <form noValidate>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Create admin work item
              </h5>
              <button type="button" className="close" data-testid="closeAddBallotModal" data-dismiss="modal" aria-label="Close" disabled={isSubmitting} onClick={onClose}>
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className=" mt-3 ms-3 ">
           
              <label className={`${invalidAdminType ? "invalid-feedback block" : ""}`}>
                <i className="fas fa-asterisk"></i>
                Select one of the admin work item types below:
              </label>
              <div className="col-md-12 horizontal-radio-group flex-column">
                 <div className=" ">
                    <Field
                      type="radio"
                      name="adminWorkitemType"
                      options={ADMIN_WORK_ITEM_TYPES}
                      component={ReduxRadio}
                      className="level-radio"
                      dataTestId="admin-workitem-type-radio"
                      value={selectedAdminType}
                      selectedValue={selectedAdminType}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      const value = e.target.value;
                        onReset();
                         if (value === WI_TYPE.ADMIN || value === WI_TYPE.APPEAL_ON_COS) {
                            setSelectedAdminType(value);
                            setActiveTab(value);
                          }
                        setInvalidAdminType(false);
                        const isAdmin = value === WI_TYPE.ADMIN ? 1 : 0;

                              if (value === WI_TYPE.APPEAL_ON_COS) {
                                setShowAppealModal(true);   
                              } else {
                                setShowAppealModal(false);
                              }
                    setAdminWorkitem((prevState) => ({
                      ...prevState,
                      IsAdmin: isAdmin,
                    }));
                  }}
                      fieldError={invalidAdminType}
                    />
                    </div>
                    {invalidAdminType && (
                      <div className="invalid-feedback block radiob">
                        {"Please select one of the admin work item types."}
                      </div>
                    )}
               </div>
          </div>
            {
        activeTab === WI_TYPE.ADMIN  ? (
            <div className="modal-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    {committeeDesignationData && (
                      <div className="form-group">
                        <label htmlFor="WorkitemCommittee" className={`edit-label-name ${(invalidCommittee && !isDisabled)? "invalid-feedback block" : ""}  ${isDisabled ? "label-disabled" : ""}`}>
                          <i aria-hidden="true" className="fas fa-asterisk"></i>
                          Committee
                        </label>
                        <Field name="WorkitemCommittee" clearTypeahead={clearAllTypeaheds} disabled={isDisabled || committeeDesignationData?.length === 0} id="addAdminWorkitemCommittee" required={true} labelKey="CommitteeDesignation" value={selectedCommitteeDesignation} filterBy={["CommitteeDesignation"]} component={RenderTypeahead} placeholder={committeeDesignationData?.length === 0 ? "Fetching records..." : "Type here to select"} data-testid="addAdminWorkitemCommittee" customClass={customClass} fieldError={invalidCommittee && !isDisabled } options={committeeDesignationData} selected={selectedCommitteeDesignation || []} defaultValue={selectedCommitteeDesignation} change={validateOnChange} keyDown={handleCommitteeSelectionInputKeyPress} />
                        {invalidCommittee && !isDisabled &&(
                          <div id="helpText" className="invalid-feedback block">
                            {"Committee is required."}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div className="w-100"></div>
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor="Title" className={`edit-label-name ${(invalidTitle && !isDisabled) ? "invalid-feedback block" : ""}  ${isDisabled ? "label-disabled" : ""} `}>
                      <i aria-hidden="true" className="fas fa-asterisk"></i>
                      Title
                    </label>
                    <textarea className={`form-control form-control-text-area-resize ${(invalidTitle && !isDisabled)? "is-invalid" : ""}`} onChange={onTitleChange} name="Title" data-testid="EmergencyDescription" id={"EmergencyDescription"} value={selectedTitle} placeholder="Click here to type"  disabled={isDisabled} />
                    {invalidTitle && !isDisabled &&(
                      <div id="helpText" className="invalid-feedback">
                        {"Title is required."}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-6 form-group">
                  <label htmlFor="TechnicalContactName" className={` ${isDisabled ? "label-disabled" : ""} `}>
                    <i aria-hidden="true"></i>Technical Contact
                  </label>
                  <Typeahead
                    key={memberList.length}
                    disabled={selectedCommitteeDesignation.length === 0}
                    id={"TechnicalContactName"}
                    className="technicalContactDropdown"
                    options={memberList}
                    emptyLabel={isLoadingMembers ? "Fetching records..." : "No match found."}
                    ref={technicalContactRef}
                    clearButton={true}
                    data-testid="TechnicalContactName"
                    onChange={(value) => {
                      setTechnicalContact(value);
                      setAdminWorkitem((prevState) => {
                        return { 
                          ...prevState, 
                          TechnicalContactId: value[0] && typeof value[0] === 'object' && value[0].hasOwnProperty('value') ? value[0].value : null
                    }});
                    }}
                    placeholder="Type here to select"
                    selected={technicalContact}
                  />
                  <div id="helpText" className="invalid-feedback"></div>
                </div>
              </div>
            </div>
          ) : (
             <AppealOnCOSForm
              committeeDesignationData={committeeDesignationData}
              selectedCommitteeDesignation={selectedCommitteeDesignation}
              setselectedCommitteeDesignation={setselectedCommitteeDesignation}
              invalidCommittee={invalidCommittee}
              validateOnChange={validateOnChange}
              handleCommitteeSelectionInputKeyPress={handleCommitteeSelectionInputKeyPress}
              clearAllTypeaheds={clearAllTypeaheds}
              customClass={customClass}
              selectedTitle={selectedTitle}
              invalidTitle={invalidTitle}
              onTitleChange={onTitleChange}
              memberList={memberList}
              technicalContact={technicalContact}
              setTechnicalContact={setTechnicalContact}
              technicalContactRef={technicalContactRef}
              isLoadingMembers={isLoadingMembers}
              setAdminWorkitem={setAdminWorkitem}
            />
        )
        }
            <div className="modal-footer">
              <button type="button" className="btn astm-btn btn-light" disabled={isSubmitting} onClick={onClose} data-testid="AddNewBallotCancel">
                Cancel
              </button>
              <button type="button" className="btn astm-btn btn-secondary" data-dismiss="modal" data-testid="AddNewBallotSubmit" onClick={handleSubmit}>
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default reduxForm<any, AddAdminWorkitemModalProps>({
  form: "AddAdminWorkitemModal",
  onSubmitFail: () => scrollToErrorOnFormHandler(),
})(AddAdminWorkitemModal);